import { Avatar, Button, Flex } from 'antd';
import { ChatHistoryModelItem } from 'api/FlowAiApi';
import chatBotIcon from 'assets/chat-bot-icon.svg';
import './ModelBubble.css';

type AllProps = {
  data: ChatHistoryModelItem;
  isLastItem: boolean;
  onQuickAnswer: (answer: string) => void;
};

function ModelBubble({ data, isLastItem, onQuickAnswer }: AllProps) {
  return (
    <div className="model-bubble-container">
      <Flex align="start" gap={10}>
        <div>
          <Avatar size={40} src={chatBotIcon} className="avatar" shape="circle" />
        </div>
        <div className="model-bubble">{data.message.question}</div>
      </Flex>

      {isLastItem && (
        <div className="model-bubble-answers">
          {(data.message.answer_type === 'choice_strict' || data.message.answer_type === 'choice_allow_other') &&
            data.message.options?.map((choice) => (
              <div className="quick-answer" key={choice.label}>
                <Button size="small" onClick={() => onQuickAnswer(choice.label)}>
                  {choice.label}
                </Button>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default ModelBubble;
